export const ITEM_PER_PAGE = 10;
export const MAX_QUICK_SELECT = 200;
export const MIN_DISPLAY_QUICK_SELECT = 100;